import api from '../api/index'
// import utils from '../../utils/raceutils'

const state = {
  athletes: {},
  athlete: {},
  athleteInterval: null,
  focusedAthlete: '',
  sortedAthletes: []
}

const mutations = {
  setAthletes (state, payload) {
    state.athletes = payload
  },
  setAthlete (state, payload) {
    state.athlete = payload
  },
  setFocusAthlete (state, payload) {
    state.focusedAthlete = payload
  },
  setSortedAthletes (state, payload) {
    state.sortedAthletes = payload
  }
}

const actions = {
  focusAthlete (context, athleteid) {
    context.commit('setFocusAthlete', athleteid)
  },
  loadRaceAthletes (context, {raceId, update}) {
    if(!update) context.commit('setAthletes', {}) // used to make the athletes go away whilst wait for the new athletes to load
    api.getRaceAthletes(raceId, function (data) {
      var object= {}
      let teams = {}
      var sorted = []
      for(var i=0;i<data.length;i+=1)
      {
        if(data[i].team_id !== null) {
          if(data[i].team_id in teams) continue
          teams[data[i].team_id] = true;
        }
        object[data[i].id]=data[i];
        sorted.push(data[i].id)
      }
      context.commit('setSortedAthletes', sorted)
      context.commit('setAthletes', object)
    })
  },
  loadRaceAthlete(context, athleteId) {
    if(athleteId) {
      api.getRaceAthlete(athleteId, function(data) {
        context.commit('setAthlete', data)
      })
    }
  },
  removeRaceAthlete(context) {
    context.commit('setAthlete', {})
  }
}

const getters = {
  athletes: (state, context) => {
    return state.athletes
  },
  athlete: state => {
    return state.athlete
  },
  getLoadedRaceAthlete: state => {
      return state.athlete ? state.athletes[state.athlete.id] : null
  },
  focusedAthlete: state => {
    return state.athletes[state.focusedAthlete]
  },
  sortedAthletes: state => {
    return state.sortedAthletes.map(id => state.athletes[id])
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/athletes.js